import React from "react";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { LanguageSelection } from "../../../Components/molecules/AuthForms/LanguageSelection";
import { AuthWrap } from "../../../Components/templates/AuthWrap/AuthWrap";

export const LanguageSelect = () => {
  const { t } = useTranslation(["glossary"]);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <AuthWrap
      pageTitle={t && t("glossary:auth.language.title")}
      pageSubheading={t && t("glossary:auth.language.subheading")}
      itemsAlightment={"center"}
      formWidth={"350px"}
    >
      <LanguageSelection
        onClick={(code) => {
          if (location?.state?.pageName === "reset-password") {
            navigate(location?.state?.url, { state: { lang: code } });
          } else if (location?.state?.pageName === "forgot-password") {
            navigate(location?.state?.url, { state: { lang: code } });
          } else navigate("/signin/enter-username", { state: { lang: code } });
        }}
      />
    </AuthWrap>
  );
};
